type ReleaseItem = {
  id: string;
  name: string;
  description: string;
  type: string;
  url: string;
  link?: string;
  linkText?: string;
};

/*
  Current release types are
  - feature
  - improvement
  - bug

  To add a new type the releaseType helpers file should be updated accordingly.
*/

export const releaseItems: ReleaseItem[] = [
  {
    id: '1',
    name: 'We‘ve moved a few things around',
    description:
      'The Console has been removed and it‘s features moved. You will now find deployment logs, execution trace history, embedded users, and the runtime test features in their respective tabs, alongside all existing tabs.',
    type: 'improvement',
    url: '',
  },
  {
    id: '2',
    name: 'Embedded users update',
    description:
      'For your Embedded users, now located in an integration tab - including a re-design and updated UX, you can now manage activated users, including updating their activation variables and viewing active connections.',
    type: 'improvement',
    url: '',
  },
  {
    id: '3',
    name: 'File saving updates',
    description: `Integration files can now be saved individually, allowing for greater control in your projects. We have also relocated the 'Save All' button inside of the Build tab so it is more contextually relevant.`,
    type: 'improvement',
    url: '',
  },
  {
    id: '4',
    name: 'Version history',
    description: `We now have version history for your Integrations. Rollback, roll forward, and deploy from any version. Version history is available in the header of the integration page.`,
    type: 'feature',
    url: '',
  },
  {
    id: '5',
    name: 'Accept / Undo file changes',
    description: `You can now accept or undo AI modified file changes in the Build tab.`,
    type: 'feature',
    url: '',
  },
  {
    id: '6',
    name: 'Deleting files from Integration',
    description: `Deleted files are now handled and tracked correctly. Save to sync and remove recently deleted files from the integration.`,
    type: 'bug',
    url: '',
  },
  {
    id: '7',
    name: 'Gemini 3 Flash support',
    description: `We have added Gemini 3 Flash as an AI model option in the Build tab.`,
    type: 'improvement',
    url: '',
  },
  {
    id: '8',
    name: 'Connect tab UI/UX update',
    description: `The Connect tab has been redesigned to be more user-friendly and intuitive. The new design removes the sidebar once used for connecting and managing connectors, and instead displays the connector details in the main content area. Creating new connections, configuring an embedded connector, or selecting an existing connection is now quicker and more seamless. You will still find the connector endpoints, discovered during planning, available to test.`,
    type: 'improvement',
    url: '',
    link: 'https://docs.versori.com/latest/guides/getting-started/connect',
    linkText: 'Check out the docs',
  },
  {
    id: '9',
    name: 'Multiple chat support',
    description: `The Build chat now supports multiple chats.`,
    type: 'feature',
    url: '',
  },
  {
    id: '10',
    name: 'Chat deletion',
    description: `The deletion of chats in Build is now possible. Helpful for tidying up stale conversations.`,
    type: 'improvement',
    url: '',
  },
  {
    id: '11',
    name: 'Logs filtering',
    description: `You can now combine filtering options to include or exclude specific values in the logs tab.`,
    type: 'improvement',
    url: '',
  },
  {
    id: '12',
    name: 'Connect tab V2',
    description: `The connect tab has gone through a slight redesign, building upon the existing design to improve the user experience. Also, a few added features have been included to provide more information, including - the usage of connections across all projects/environments, visibility into deleted authentication methods, the option to remove a connection from a connector, and a universal delete connection option.`,
    type: 'improvement',
    url: '',
  },
  {
    id: '13',
    name: 'User preferences',
    description: `You can now set your preferred build view, code or flow, in user preferences. Preferences is available in your account page.`,
    type: 'feature',
    url: '',
  },
  {
    id: '14',
    name: 'Webhook tab UI/UX update',
    description: `The webhook tab has been re-designed. All project webhook information can be found here.`,
    type: 'improvement',
    url: '',
  },
  {
    id: '15',
    name: 'Skills',
    description: `You can now build and manage a library of Skills for your organisation. Upload skill bundles to give the AI reusable, organisation-specific knowledge and instructions to draw on when planning and building your integrations. Skills are available in organisation settings.`,
    type: 'feature',
    url: '',
    link: 'https://docs.versori.com/latest/ai-tooling/skills',
    linkText: 'Learn more about Skills',
  },
  {
    id: '16',
    name: 'Unified Agent chat',
    description: `We have unified the Plan and Build Agent chats into a single chat interface. The workspace page layout has been updated to include the new chat interface. Research and workflows are now part of the integration codebase.`,
    type: 'feature',
    url: '',
    link: 'https://docs.versori.com/latest/guides/getting-started/chat',
    linkText: 'Learn more about unified agent chat',
  },
  {
    id: '17',
    name: 'Field Mapping with AI',
    description: `Map fields between your connected systems in the new Field Mapping tab, with AI-assisted expressions and transformation pipelines. Take the guided tour to learn your way around.`,
    type: 'feature',
    url: '',
    link: 'https://docs.versori.com/latest/guides/getting-started/build/field-mapping',
    linkText: 'Learn more about Field Mapping',
  },
];
